import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { take } from 'rxjs/operators';

import { isNullOrUndefined } from '../../../util/is-null-or-undefined.util';
import { SessaoService } from '../../charon/services/sessao.service';

@Injectable({
  providedIn: 'root',
})
export class GuardiaoService {
  constructor(
    public roteador: Router,
    private servicoSessao: SessaoService,
  ) {}

  /**
   * Método que verifica se o usuário está autenticado
   */
  estaAutenticado(): boolean {
    if (!this.servicoSessao.estaAutenticado()) return false;
    return true;
  }
  /**
   * Método que habilita/desabilita carregamento da página
   */
  canLoad(): boolean {
    if (!this.estaAutenticado()) {
      this.enviarParaLogin();
      return false;
    }
    return true;
  }

  /**
   * Método que direciona o usuário para a home
   */
  enviarParaHome(): void {
    this.roteador.navigate(['/home']);
  }

  /**
   * Redireciona o usuário para a página de login
   */
  enviarParaLogin(explicitLogout: boolean = false): void {
    const ua = typeof navigator !== 'undefined' ? (navigator.userAgent || '') : '';
    if (explicitLogout) {
      this.servicoSessao.notificarLogout(ua).pipe(take(1)).subscribe({ error: () => {} });
    }
    this.servicoSessao.excluirSessao();

    this.roteador.navigate(['/login']);
  }
}
